import { SignUpService } from "./SignUpService";

export type { OnboardingCustomerParams, OnboardingCustomerResult } from "./SignUpService";

export const signUpService = new SignUpService();
